<template>
  <div class="sortable-page-pickers">
    <Draggable
      :value="pages"
      :animation="200"
      @input="onOrderChange($event)"
    >
      <div
        v-for="(page, idx) in pages"
        :key="`page-${idx}`"
        class="sortable-page-pickers__item"
      >
        <MeetingStep
          v-model="pages[idx]"
          :index="idx"
          :no-meeting-pages="noMeetingPages"
          :screen-saver="screenSaver"
          @input="pageInput"
          @removeStep="removePage(page.id, idx)"
        />
      </div>
    </Draggable>
    <div
      class="generic-border generic-border--text-btn v-centerer sortable-page-pickers__add"
      @click="addPage"
    >
      <div class="generic-border__left">
        <Icon class="generic-border__left-blue-icon">{{ addExtraBold }}</Icon>
        <span>{{ $t("message.ADD_PAGE") }}</span>
      </div>
      <Icon class="generic-border__right-arrow">{{ arrowDownLine }}</Icon>
    </div>
  </div>
</template>

<script>
/**
 * Allow editing a sortable array of meeting-step-like components.
 *
 * @vue-prop {Object} value - Array of pages
 */

import { cloneDeep } from 'lodash';
// Components
import Draggable from 'vuedraggable';
import Icon from '@/components/icon.vue';
import MeetingStep from '@/components/meeting-step.vue';
// Utils and assets
import { preventPastingStyles } from '@/utils/main';
import { addExtraBold, arrowDownLine } from '@/assets/icons/';

export default {

  name: 'SortablePagePickers',

  components: {
    Draggable,
    Icon,
    MeetingStep,
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
    screenSaver: Boolean,
    noMeetingPages: Boolean,
  },

  data() {
    return {
      addExtraBold,
      arrowDownLine,
      pages: this.value,
    };
  },

  watch: {
    value(newVal) {
      this.pages = cloneDeep(newVal);
      this.$nextTick(preventPastingStyles);
    },
  },

  methods: {
    onOrderChange(list) {
      if (this.screenSaver) {
        const params = { ids: list.map(page => page.id) };
        this.App.post('/server/screenSaver/setOrder.php', params, (data) => {
          if (data instanceof Array) {
            this.$emit('input', data);
          }
        });
      } else {
        this.$emit('input', list);
      }
    },
    pageInput(page) {
      if (this.screenSaver) {
        this.App.post('/server/screenSaver/setPage.php', page, (data) => {
          if (data instanceof Array) {
            this.$emit('input', data);
          }
        });
      } else {
        this.$emit('input', this.pages);
      }
    },
    /** Append a new page in the array */
    addPage() {
      if (this.screenSaver) {
        this.App.post('/server/screenSaver/createPage.php', {}, (data) => {
          if (data instanceof Array) {
            this.$emit('input', data);
          }
        });
      } else {
        this.$emit('input', [...this.pages, { pageId: 0, name: '', info: '', duration: 5 }]);
      }
    },
    /** Append a new page in the array */
    removePage(id, idx) {
      if (this.screenSaver) {
        this.App.post('/server/screenSaver/removePage.php', { id }, (data) => {
          if (data instanceof Array) {
            this.$emit('input', data);
          }
        });
      } else {
        const list = cloneDeep(this.pages);
        list.splice(idx, 1);
        this.$emit('input', list);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.sortable-page-pickers {

  &__item {
    margin-top: .7rem;
  }

  &__add {
    margin-top: .7rem;
    max-width: 25rem;

    &.generic-border--text-btn {
      background: #fff;
    }
  }

  .meeting-step {
    cursor: grab;

    > * {
      cursor: initial;
    }
  }
}

</style>
